import { render, staticRenderFns } from "./editDemo.vue?vue&type=template&id=7bf00421&scoped=true"
import script from "./editDemo.vue?vue&type=script&lang=js"
export * from "./editDemo.vue?vue&type=script&lang=js"
import style0 from "./editDemo.vue?vue&type=style&index=0&id=7bf00421&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf00421",
  null
  
)

export default component.exports